/* Autoplay videos in slideshow when they enter the viewport
 * Targets: video.slideshow__slide_media_desc and video.slideshow__slide_media_mob
 * Behavior: play when sufficiently visible; pause when out of view.
 * Safe to include multiple times; guarded by global flag.
 */
(function() {
  if (window.__slideshowVideoAutoplayInitialized) return;
  window.__slideshowVideoAutoplayInitialized = true;

  const SELECTOR = 'video.slideshow__slide_media_desc, video.slideshow__slide_media_mob, .slideshow__slide_media_desc video, .slideshow__slide_media_mob video, .slideshow-video video, .video-desktop video, .video-mobile-only video';
  const VISIBLE_THRESHOLD = 0.2; // 20% visible is considered in-view

  const observed = new WeakSet();
  let io = null;
  let fallbackBound = false;

  function prepareVideo(v) {
    try { v.muted = true; } catch (e) {}
    try { v.volume = 0; } catch (e) {}
    try { v.setAttribute('muted', ''); } catch (e) {}
    try { v.setAttribute('playsinline', ''); } catch (e) {}
    try { v.setAttribute('preload', v.getAttribute('preload') || 'auto'); } catch (e) {}
    try { v.removeAttribute('poster'); } catch (e) {}
  }

  function tryPlay(v) {
    try {
      // Ensure ready state is kicked if nothing loaded
      if (v.readyState === 0) {
        try { v.load(); } catch (e) {}
      }
      const p = v.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function(){ /* Ignore autoplay rejections (should be muted so OK) */});
      }
    } catch (e) {}
  }

  function tryPause(v) {
    try { v.pause(); } catch (e) {}
  }

  function onIntersect(entries) {
    entries.forEach((entry) => {
      const v = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= VISIBLE_THRESHOLD) {
        v.dataset.inViewport = 'true';
        prepareVideo(v);
        tryPlay(v);
      } else {
        v.dataset.inViewport = 'false';
        tryPause(v);
      }
    });
  }

  function isVis(el) {
    const rect = el.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const vw = window.innerWidth || document.documentElement.clientWidth;
    if (rect.width <= 0 || rect.height <= 0) return false;
    const horizontallyIn = rect.right > 0 && rect.left < vw;
    const verticallyIn = rect.bottom > 0 && rect.top < vh;
    if (!horizontallyIn || !verticallyIn) return false;
    const visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
    const visibleWidth = Math.min(rect.right, vw) - Math.max(rect.left, 0);
    const visibleArea = Math.max(0, visibleHeight) * Math.max(0, visibleWidth);
    const totalArea = rect.width * rect.height;
    const ratio = totalArea > 0 ? visibleArea / totalArea : 0;
    return ratio >= VISIBLE_THRESHOLD;
  }

  function fallbackCheck() {
    document.querySelectorAll(SELECTOR).forEach((v) => {
      if (!document.body.contains(v)) return;
      prepareVideo(v);
      if (isVis(v)) {
        v.dataset.inViewport = 'true';
        tryPlay(v);
      } else {
        v.dataset.inViewport = 'false';
        tryPause(v);
      }
    });
  }

  function bindFallback() {
    if (fallbackBound) return;
    fallbackBound = true;
    ['scroll', 'resize', 'orientationchange'].forEach((ev) => {
      window.addEventListener(ev, fallbackCheck, { passive: true });
    });
    // Initial check
    fallbackCheck();
  }

  function scan(root) {
    const scope = root || document;
    const vids = scope.querySelectorAll(SELECTOR);
    vids.forEach((v) => {
      if (observed.has(v)) return;
      observed.add(v);
      prepareVideo(v);
      if (io) {
        try { io.observe(v); } catch (e) {}
      }
    });

    // For browsers without IO, run fallback once after attaching
    if (!('IntersectionObserver' in window)) {
      bindFallback();
    } else {
      // Run an initial visibility pass to start in-view videos immediately
      try {
        vids.forEach((v) => {
          const rect = v.getBoundingClientRect();
          const vh = window.innerHeight || document.documentElement.clientHeight;
          const vw = window.innerWidth || document.documentElement.clientWidth;
          const visible = rect.bottom > 0 && rect.top < vh && rect.right > 0 && rect.left < vw;
          if (visible) tryPlay(v);
        });
      } catch (e) {}
    }
  }

  function init() {
    if ('IntersectionObserver' in window) {
      if (!io) io = new IntersectionObserver(onIntersect, { threshold: [0, VISIBLE_THRESHOLD, 0.5, 1] });
    }
    scan(document);
  }

  // Pause all when tab hidden; resume those in view when visible
  document.addEventListener('visibilitychange', function() {
    const vids = document.querySelectorAll(SELECTOR);
    if (document.hidden) {
      vids.forEach((v) => tryPause(v));
    } else {
      vids.forEach((v) => {
        if (v.dataset.inViewport === 'true') tryPlay(v);
      });
    }
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function(e) { scan(e.target || document); });
  document.addEventListener('shopify:section:unload', function(e) {
    const scope = e.target || document;
    if (io) {
      scope.querySelectorAll(SELECTOR).forEach((v) => { try { io.unobserve(v); } catch (e) {} });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
